import { Component, OnInit, OnDestroy, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  CurrencyService,
  CurrencyContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyComponent implements OnInit, OnDestroy {

  @Input() currency: FormControl = new FormControl(null, Validators.required);
  @Input() label: string;
  @Input() placeholderLabel: string;
  @Input() noEntriesFoundLabel: string;
  @Input() errorMessage: string;
  @Output() currencyChange = new EventEmitter<any>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<CurrencyContainerModel[]> = new ReplaySubject<CurrencyContainerModel[]>(1);
  currencyList: CurrencyContainerModel[];

  constructor( private currencyService: CurrencyService ) {}

  ngOnInit() {
    this.subs.sink = this.currencyService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.currencyList = resolve.data;
        this.filteredOptions$.next(this.currencyList);
      }});
    this.currency.markAsTouched();
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.currencyList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.currencyList.filter(c => c.bl_fi_mst_ccy.display_short.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(value: string) {
    console.log("currency select", value);
    this.currency.patchValue(value);
    this.currencyChange.emit(value);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
